import { useQuery } from "@tanstack/react-query";
import { AxiosRequestConfig } from "axios";

import * as api from "@/api/api";
import {
  SearchCompaniesRequest,
  SearchCompaniesResponse,
} from "@/types/proto/exabel/kpi/external_adc_service";

export const useAdcCompanySearch = (searchTerm: string) => {
  return useQuery({
    queryKey: ["adcCompanySearch", searchTerm],
    queryFn: ({ signal }) => searchCompanies({ query: searchTerm }, { signal }),
    enabled: searchTerm.length > 0,
  });
};

const searchCompanies = (
  request: SearchCompaniesRequest,
  config?: AxiosRequestConfig
) => {
  return api.post<SearchCompaniesResponse, SearchCompaniesRequest>(
    "adc/v1/companies:search",
    request,
    undefined,
    config
  );
};
